import type { Dictionary } from "./types.js";
import { en } from "./en.js";

export type { Dictionary };

export const dictionaries: Record<string, Dictionary> = { en };
const loaders: Record<string, () => Promise<Dictionary>> = {
  es: () => import("./es.js").then((module) => module.es),
  pt: () => import("./pt.js").then((module) => module.pt),
  fr: () => import("./fr.js").then((module) => module.fr),
  de: () => import("./de.js").then((module) => module.de),
  ru: () => import("./ru.js").then((module) => module.ru),
  zh: () => import("./zh.js").then((module) => module.zh),
  ja: () => import("./ja.js").then((module) => module.ja)
};
const pending = new Map<string, Promise<void>>();

/** Fetch only the selected locale; concurrent callers share the same import. */
export function loadDictionary(code: string): Promise<void> {
  if (dictionaries[code] || !loaders[code]) return Promise.resolve();
  const existing = pending.get(code);
  if (existing) return existing;
  const request = loaders[code]().then((dictionary) => { dictionaries[code] = dictionary; })
    .finally(() => pending.delete(code));
  pending.set(code, request);
  return request;
}
